import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CommentType } from '@app/core/messaging';
import { Quotation } from '@app/core/quotes';

@Component({
  selector: 'cnc-quotation-messages',
  templateUrl: './quotation-messages.component.html',
  styleUrls: ['./quotation-messages.component.scss'],
})
export class QuotationMessagesComponent implements OnInit {
  pageTitle :string = '';
  commentType :CommentType;
  showForm :boolean = false;
  @Input() quotation :Quotation;

  constructor(public activeModal :NgbActiveModal) {}

  ngOnInit() {
    this.pageTitle = 'Quote from ' + this.quotation.country;
    this.commentType = {
      ref_tab_type: 2,
      ref_tab_id: this.quotation.id,
    };
    this.showForm = true;
  }
}
